export default __webpack_public_path__ + "static/0115-90a56ed96f036572a825e3d010fbea16.png";